/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP20_ANSWERS = [
    'Bethany talks to Stephanie on the phone. She wonders if Tony could visit his cousins, Holly and Harry this vacation.',
    'Tony comes home from school. He finds out that he will visit his cousins and go on a plane. He’s very excited.',
    'The family goes shopping to get things for Tony’s trip.',
    'At a big supermarket, Bethany and Howard are going to buy a suitcase first. But Tony’s more interested in something else. So he walks around the store.',
    'Tony sees curtains. He remembers breaking the curtains at home.',
    'In the pet section, Tony sees a beetle. He remembers a beetle at school biting his finger.',
    'Lastly, Tony sees soccer balls and basketballs. He remembers finding balls on his friend’s roof.',
    'Tony gets to the checkout just in time. He wants a new backpack and tells his mom they forgot it. Luckily, his mom buys it for him.',
    'At the airport, Tony meets a flight attendant who will take care of him. Tony and the flight attendant go through departures.',
    'Uncle Matt meets Tony at Oregon airport. He has a big banner that says “Welcome to Oregon, Tony!”',
    'Tony tells Uncle Matt about the flight. Tony accidentally broke a few things on the plane.',
    'Uncle Matt and Tony drive to Holly and Harry’s house so Tony can meet his cousins.',
];

// export const HHT1_EP20_ANSWER_SOUNDS = [
//     '/1_EP20_SB_TL_01.mp3',
//     '/1_EP20_SB_TL_02.mp3',
//     '/1_EP20_SB_TL_03.mp3',
//     '/1_EP20_SB_TL_04.mp3',
//     '/1_EP20_SB_TL_05.mp3',
//     '/1_EP20_SB_TL_06.mp3',
//     '/1_EP20_SB_TL_07.mp3',
//     '/1_EP20_SB_TL_08.mp3',
//     '/1_EP20_SB_TL_09.mp3',
//     '/1_EP20_SB_TL_10.mp3',
//     '/1_EP20_SB_TL_11.mp3',
//     '/1_EP20_SB_TL_12.mp3',
// ];

export const HHT1_EP20_ANSWER_SOUNDS = [
    '/9d26aa181fbefd6fcf0e1a772462f421.mp3',
    '/ed0a2355d3fed2f084346762f162455b.mp3',
    '/1c0914d205190138f78480bdfe695b01.mp3',
    '/2d3697ec1e1b8047465b941b1a70b693.mp3',
    '/1da87961cf156cba54b80d9c31531a58.mp3',
    '/b39b747fcc03bee65bb97ba3cd2708e6.mp3',
    '/440f5b9e78ed40e11356b1bc6f7bd4ee.mp3',
    '/0e0080f892ba220428e7ac942f921dd1.mp3',
    '/c2f2efbeda99cc6f84d2d936d281656c.mp3',
    '/0322b2084b22ccd0763ff0068507cea1.mp3',
    '/8b6b2aaedc3373b6d118770c6604886b.mp3',
    '/42d9c0c7ee14ef2fbb969e92b62e0fa5.mp3',
];

export const HHT1_EP20_QUIZ_ITEMS = [{
    'A': HHT1_EP20_ANSWERS[1],
    'B': HHT1_EP20_ANSWERS[10],
    'SoundIndexA': 1,
    'SoundIndexB': 10,
    'answer': HHT1_EP20_ANSWERS[1],
    'sound': [2],
    'exception': false,
},
    {
        'A': HHT1_EP20_ANSWERS[9],
        'B': HHT1_EP20_ANSWERS[3],
        'SoundIndexA': 9,
        'SoundIndexB': 3,
        'answer': HHT1_EP20_ANSWERS[3],
        'sound': [4],
        'exception': false,
    },
    /**
     * 특이사항
     * 답을 풀고 다음 퍼즐 /음성 , 퍼즐 /음성 , 이미지 사진만 노출
     */
    {
        'A': HHT1_EP20_ANSWERS[5],
        'B': HHT1_EP20_ANSWERS[0],
        'SoundIndexA': 5,
        'SoundIndexB': 0,
        'answer': HHT1_EP20_ANSWERS[5],
        'sound': [6, 7],
        'exception': true,
    },
    {
        'A': HHT1_EP20_ANSWERS[2],
        'B': HHT1_EP20_ANSWERS[8],
        'SoundIndexA': 2,
        'SoundIndexB': 8,
        'answer': HHT1_EP20_ANSWERS[8],
        'sound': [9, 10],
        'exception': false,
    },
    /**
     * 특이사항
     * 문자 풀고 다음 퍼즐 / 음성이 없음
     */
    {
        'A': HHT1_EP20_ANSWERS[11],
        'B': HHT1_EP20_ANSWERS[4],
        'SoundIndexA': 11,
        'SoundIndexB': 4,
        'answer': HHT1_EP20_ANSWERS[11],
        'sound': [11],
        'exception': false,
    },

]
